import { ActionPayloadValidationError } from "./ReplayPayloadValidation";

/**
 * Shared helpers for parsing/validating mask strings used in replay payloads.
 *
 * Mask format:
 * - string of '0' and '1'
 * - index mapping is linearized grid index (0..N-1)
 *
 * NOTE:
 * - We do NOT enforce expected length here because the engine is game-agnostic.
 *   Game can enforce length via grid size if needed.
 */
export function parseBinaryMaskToIndices(actionTypeName: string, fieldName: string, mask: string): number[] {
    const indices: number[] = [];
  
    for (let i = 0; i < mask.length; i++) {
      const ch = mask[i];
      if (ch !== "0" && ch !== "1") {
        throw new ActionPayloadValidationError(actionTypeName, fieldName, "Mask must contain only '0' and '1'.");
      }
      if (ch === "1") indices.push(i);
    }
  
    return indices;
  }